"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerAdminUpdatePasswordTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.HaulerAdminUpdatePasswordTransport = typebox_1.Type.Object({
    newPassword: typebox_1.Type.String({
        minLength: 8,
        maxLength: 128,
        pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])',
    }),
});
//# sourceMappingURL=hauler-admin.js.map